import { getPriceMatchingFAQ } from '~/util/faqLinks';

type BannerData = {
  link: string;
  icon: string;
  title: string;
  subTitle: string;
};

const defaultBannerData: BannerData[] = [
  {
    link: '/faq/115002839971-does-zola-offer-free-shipping-',
    icon: 'zolaicon-fast-shipping',
    title: 'Free Shipping & Returns',
    subTitle: 'details',
  },
  {
    link: getPriceMatchingFAQ(),
    icon: 'zolaicon-customer-service',
    title: 'Price Matching',
    subTitle: 'details',
  },
  {
    link: '/faq/115002837952-how-do-we-use-our-20-post-wedding-discount-',
    icon: 'zolaicon-post-wedding-discount',
    title: 'Post-Wedding Discount',
    subTitle: 'details',
  },
] as BannerData[];

export default defaultBannerData;

export const weddingShopBannerData: BannerData[] = [
  {
    link: '/faq/115002839971-does-zola-offer-free-shipping-',
    icon: 'zolaicon-fast-shipping',
    title: 'Free Shipping & Returns',
    subTitle: 'details',
  },
  {
    link: getPriceMatchingFAQ(),
    icon: 'zolaicon-customer-service',
    title: 'Price Matching',
    subTitle: 'details',
  },
  {
    link: '/shop/brands/wedding-shop',
    icon: 'zolaicon-best-brand-gifts',
    title: "Today's Best Wedding Brands",
    subTitle: 'details',
  },
];
